import type { GetContractPageDataResponse } from '@weft/api-definition';
import { GetContractPageDataResponseSchema } from '@weft/api-definition';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';

export function useContractPage(contractId: string, options?: CustomUseQueryOptions<GetContractPageDataResponse>) {
  const queryKey = getQueryKey(contractId);
  const queryFunction = getQueryFunction(contractId);
  
  return useQuery(queryKey, queryFunction, options);
}

export async function prefecthContractPage(contractId: string, queryClient: QueryClient) {  
  const queryKey = getQueryKey(contractId);
  const queryFunction = getQueryFunction(contractId);
  
  await queryClient.prefetchQuery(queryKey, queryFunction);
}

function getQueryKey(contractId: string) {
  return ['contractPage', contractId];
}

function getQueryFunction(contractId: string) {
  return () => {
    return getContractPageData(contractId);
  };
}

async function getContractPageData(contractId: string) {
  const api = getPrivateApi();
  const getContractPageDataResponse = await api.getContractPageData({ contractId });

  return GetContractPageDataResponseSchema.parse(getContractPageDataResponse);
}